var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"conter-container"},[_c('div',{ref:"myChart",staticClass:"tp-chart"})])
}
var staticRenderFns = []

export { render, staticRenderFns }